module.exports = __webpack_public_path__ + "img/banner1.cd743e2f.png";